"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _ListSubheader = _interopRequireDefault(require("@material-ui/core/ListSubheader"));

var _styles = require("@material-ui/core/styles");

var _reactWindow = require("react-window");

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderRow = function renderRow(props) {
  var data = props.data,
      index = props.index,
      style = props.style;
  return /*#__PURE__*/_react.default.cloneElement(data[index], {
    style: _objectSpread(_objectSpread({}, style), {}, {
      top: style.top
    })
  });
};

var OuterElementContext = /*#__PURE__*/_react.default.createContext({});

var OuterElementType = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var outerProps = _react.default.useContext(OuterElementContext);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: ref
  }, props, outerProps));
});

function useResetCache(data) {
  var ref = _react.default.useRef(null);

  _react.default.useEffect(function () {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);

  return ref;
}

var ListboxComponent = /*#__PURE__*/_react.default.forwardRef(function ListboxComponent(props, ref) {
  var children = props.children,
      other = _objectWithoutProperties(props, _excluded);

  var itemData = _react.default.Children.toArray(children);

  var theme = (0, _styles.useTheme)();
  var smUp = (0, _useMediaQuery.default)(theme.breakpoints.up('sm'), {
    noSsr: true
  });
  var itemCount = itemData.length;
  var itemSize = smUp ? 36 : 48;

  var getChildSize = function getChildSize(child) {
    if ( /*#__PURE__*/_react.default.isValidElement(child) && child.type === _ListSubheader.default) {
      return 48;
    }

    return itemSize;
  };

  var getHeight = function getHeight() {
    if (itemCount > 8) {
      return 8 * itemSize;
    }

    return itemData.map(getChildSize).reduce(function (a, b) {
      return a + b;
    }, 0);
  };

  var gridRef = useResetCache(itemCount);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(OuterElementContext.Provider, {
    value: other
  }, /*#__PURE__*/_react.default.createElement(_reactWindow.VariableSizeList, {
    itemData: itemData,
    height: getHeight() + 2,
    width: "100%",
    ref: gridRef,
    outerElementType: OuterElementType,
    innerElementType: "ul",
    itemSize: function itemSize(index) {
      return getChildSize(itemData[index]);
    },
    overscanCount: 5,
    itemCount: itemCount
  }, renderRow)));
});

ListboxComponent.propTypes = {
  children: _propTypes.default.node
};
var useStyles = (0, _styles.makeStyles)({
  listbox: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0
    }
  }
});

var VirtualAutoComplete = function VirtualAutoComplete(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, _extends({}, props, {
    disableListWrap: true,
    classes: classes,
    ListboxComponent: ListboxComponent
  }));
};

var _default = VirtualAutoComplete;
exports.default = _default;